import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { RESERVED_PROFILE_PATHS } from './app.routes';

function isPublicCardPath(url: string): boolean {
  const segment = url.split('?')[0].split('#')[0].replace(/^\//, '');
  return /^[a-zA-Z0-9_-]+$/.test(segment) && !RESERVED_PROFILE_PATHS.has(segment);
}

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const router = inject(Router);
  const auth = inject(AuthService);

  // Skip interceptor for authentication endpoints
  if (request.url.includes('signIn.php') ||
      request.url.includes('signup.php') ||
      request.url.includes('google_login.php') ||
      request.url.includes('logOut.php') ||
      request.url.includes('forgot_password.php') ||
      request.url.includes('reset_password.php') ||
      request.url.includes('verifyEmail.php') ||
      request.url.includes('verifyUser.php') ||
      request.url.includes('get_config.php')) {
    return next(request);
  }

  // Attach Bearer from the JS-readable token when present so Home (and others)
  // authenticate immediately after sign-in even if the HttpOnly cookie is late.
  const token = auth.getClientToken();
  const authedRequest =
    token && !request.headers.has('Authorization')
      ? request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        })
      : request.clone({ withCredentials: true });

  return next(authedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403 && error.error?.code === 'email_unverified') {
        if (!router.url.startsWith('/un-verified-email') && !router.url.startsWith('/verify-email')) {
          router.navigate(['/un-verified-email']);
        }
        return throwError(() => error);
      }
      if (error.status === 401) {
        // Don't redirect from public pages or auth-related pages
        const pathOnly = router.url.split('?')[0].split('#')[0];
        if (pathOnly.startsWith('/resetPassword') ||
            pathOnly.startsWith('/forgot-password') ||
            pathOnly.startsWith('/verify-email') ||
            pathOnly.startsWith('/un-verified-email') ||
            pathOnly.startsWith('/exchangeContact') ||
            pathOnly.startsWith('/feedback') ||
            isPublicCardPath(router.url)) {
        } else if (!router.url.includes('/signin')) {
          router.navigate(['/signin']);
        }
      }
      return throwError(() => error);
    })
  );
};
